import * as z from "zod";

export const getDynamicCoverageTransformStatus = {
  name: "getDynamicCoverageTransformStatus" as const,
  input: z.object({}),
  output: z.object({ isEnabled: z.boolean() }),
};
